export const StepsViewModeEnum = {
    PROJECT: 'project',
    PRESENTATION: 'presentation',
} as const;

export type StepsViewModeType =
    (typeof StepsViewModeEnum)[keyof typeof StepsViewModeEnum];
